import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { ButtonsAction } from '@app/src/common/ButtonsAction';
import {
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Wrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';
const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  handleButtonNext?: Function;
  handleButtonPrev?: Function;
  showButtonNext?: boolean;
}

export const FormActions: React.FC<Props> = ({
  handleButtonNext,
  showButtonNext,
  handleButtonPrev
}) => {
  const dispatch = useDispatch();
  const currentDescription = useSelector(state => state.form.stepOne.values.description);
  const [isFixedActionsButtons, setIsFixedActionsButtons] = useState(false);
  let active = false;
  const [isDisabledScroll, setIsDisabledScroll] = useState(false);
  const refWrapper = useRef(null);
  const refFooter = useRef(null);

  useEffect(() => {
    if (isClient) {
      if (window.innerWidth < BREAKPOINT) {
        window.addEventListener('scroll', handleScroll);
      }
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
        if (window.innerWidth < BREAKPOINT) {
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, []);

  const handleResizeWindow = useCallback(() => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsFixedActionsButtons(false);
      window.removeEventListener('scroll', handleScroll)
    } else {
      window.addEventListener('scroll', handleScroll)
      if (active) {
        active = false;
      }
    }
  }, [dispatch]);

  const disabledScroll = () => {
    setIsDisabledScroll(false)
    setTimeout(() => {
      setIsDisabledScroll(true)
    }, 500)
  }

  const handleScroll = useCallback(() => {
    const bodyHeight = document.body.offsetHeight;
    const fixedElementHeight = refWrapper.current.offsetHeight;
    const footerHeight = refFooter.current.offsetHeight;

    if (!isDisabledScroll) {
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) > fixedElementHeight && active === false) {
        active = true;
        setIsFixedActionsButtons(true);
        disabledScroll();
      }
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) <= footerHeight && active === true) {
        active = false;
        setIsFixedActionsButtons(false)
        disabledScroll()
      }
    }
  }, [dispatch])

  return (
    <Wrapper  ref={refWrapper}>
      <ButtonActionsWrapper fixed={isFixedActionsButtons} >
            <ButtonsAction
              ButtonPrev={
                <ButtonPrevWrapper
                  background='#fff'
                  handleClick={handleButtonPrev}
                  color={COLORS.BLACK_BOLD}
                  width={120}
                  text="Regresar"
                  icon={{name:'icon-back', color: COLORS.BLACK_BOLD, width:'16'}}
                  left
                />
              }
              ButtonNext={
                <ButtonNextWrapper
                  isDisplay={showButtonNext}
                  handleClick={handleButtonNext}
                  background={COLORS.BLACK_BOLD}
                  disabled={currentDescription === ''}
                  color="#fff"
                  text="Siguiente"
                  width={140}
                  icon={{name:'icon-back', color: '#fff', width:'16'}}
                />
              }
            />
      </ButtonActionsWrapper>
      <MiniFooter refFooter={refFooter} />
    </Wrapper>
)};